import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./store";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import Keycloak from "keycloak-js";
import * as cfg from "./config";
import { BrowserRouter } from "react-router-dom";
import KeycloakWrapper from "@authzsvc/keycloak-js-react";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <KeycloakWrapper
        keycloak={
          new Keycloak({
            url: cfg.keycloakUrl,
            realm: cfg.keycloakRealm,
            clientId: cfg.keycloakClientId,
          })
        }
        refresh={true}
        keycloakParams={{
          onLoad: "login-required",
          flow: "standard",
          promiseType: "native",
        }}
      >
        <App />
      </KeycloakWrapper>
    </BrowserRouter>
  </Provider>,
);

serviceWorker.unregister();
